"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInternationalMessages = exports.getInternationalMessages = exports.InternationalizableMessagePropType = void 0;
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var InternationalizableMessagePropType = exports.InternationalizableMessagePropType = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
  id: _propTypes["default"].oneOfType([_propTypes["default"].string.isRequired, _propTypes["default"].number.isRequired]),
  description: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  defaultMessage: _propTypes["default"].string,
  values: _propTypes["default"].object
})]);
var getInternationalMessages = exports.getInternationalMessages = function getInternationalMessages(message) {
  if (!message) return '';
  if (typeof message === 'string') return message;
  var intl = (0, _reactIntl.useIntl)();
  return intl.formatMessage(message, message.values);
};
var useInternationalMessages = exports.useInternationalMessages = function useInternationalMessages() {
  for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }
  return messages.map(getInternationalMessages);
};